import { ApiServiceProps } from "DataTypes/Services/Index.type";
import { get, post } from "./index";

const searchConnection: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: "setting/search",
    isEhr: true,
    data: {
      data: payload?.data || {},
    },
  };
  return post(request);
};

const validateConnection: (payload: ApiServiceProps) => any = ({ id1 }) => {
  const request = {
    subUrl: `setting/${id1}/validate`,
    isEhr: true,
    data: {},
  };
  return post(request);
};

const errFileDownload: (payload: ApiServiceProps) => any = ({ id1 }) => {
  const request = {
    subUrl: `sync-import/practicelocation/${id1}/error-file`,
    isEhr: true,
    data: {},
    excel: true,
  };
  return post(request);
};

const manualPatientSync: (payload: ApiServiceProps) => any = ({
  id1,
  data,
}) => {
  const request = {
    subUrl: `sync/patient/practicelocation/${id1}/manual`,
    isEhr: true,
    data: { data: data || {} },
  };
  return post(request);
};

const patientResourceSync: (payload: ApiServiceProps) => any = ({
  id1,
  data,
}) => {
  const resource =
    data?.resource == "documents" ? "clinical-documents" : data?.resource;
  const request = {
    subUrl: `patient/${id1}/${resource}/sync`,
    isEhr: true,
    data: {},
  };
  return post(request);
};

const patientParallelSync: (payload: ApiServiceProps) => any = ({ id1 }) => {
  const request = {
    subUrl: `patient/${id1}/sync`,
    isEhr: true,
    data: {},
  };
  return post(request);
};

const downloadDocumentReference: (payload: ApiServiceProps) => any = ({
  id1,
  id2,
}) => {
  const request = {
    subUrl: `patient/${id1}/document-reference/${id2}/download`,
    isEhr: true,
    data: {},
    excel: true,
  };
  return post(request);
};

const downloadClinicalDocument: (payload: ApiServiceProps) => any = ({
  id1,
  id2,
}) => {
  const request = {
    subUrl: `patient/${id1}/clinical-document/${id2}/download`,
    isEhr: true,
    data: {},
    excel: true,
  };
  return post(request);
};

const pushClinicalDocument: (payload: ApiServiceProps) => any = ({
  id1,
  id2,
}) => {
  const request = {
    subUrl: `patient/${id1}/clinical-document/${id2}/push`,
    isEhr: true,
    data: {},
  };
  return post(request);
};

const pushPatientCase: (payload: ApiServiceProps) => any = ({ id1, data }) => {
  const request = {
    subUrl: `patient/${id1}/patient-case/push`,
    isEhr: true,
    data: data || {},
  };
  return post(request);
};

const searchPatientCases: (payload: ApiServiceProps) => any = ({ id1 }) => {
  const request = {
    subUrl: `patient/${id1}/patient-cases/search`,
    isEhr: true,
    data: {},
  };
  return post(request);
};

const listProviders: (payload: ApiServiceProps) => any = ({ id1 }) => {
  const request = {
    subUrl: `practice-location/${id1}/providers`,
    isEhr: true,
  };
  return get(request);
};

const prepareClaim: (payload: ApiServiceProps) => any = ({ id1, id2 }) => {
  const request = {
    subUrl: `patient/${id1}/billing/${id2}/claim/prepare`,
    isEhr: true,
  };
  return get(request);
};

const pushClaim: (payload: ApiServiceProps) => any = ({ id1, id2, data }) => {
  const request = {
    subUrl: `patient/${id1}/billing/${id2}/claim/push`,
    isEhr: true,
    data: data || {},
  };
  return post(request);
};

const createConnection: (payload: ApiServiceProps) => any = ({ data }) => {
  const request = {
    subUrl: "setting/create",
    isEhr: true,
    data: { data: data || {} },
  };
  return post(request);
};

const updateConnection: (payload: ApiServiceProps) => any = ({ id1, data }) => {
  const request = {
    subUrl: `setting/${id1}/update`,
    isEhr: true,
    data: { data: data || {} },
  };
  return post(request);
};

const deleteConnection: (payload: ApiServiceProps) => any = ({ id1 }) => {
  const request = {
    subUrl: `setting/${id1}/delete`,
    isEhr: true,
    data: {},
  };
  return post(request);
};

// --- Vendor-neutral facade (kept from development) --------------------------
// development wired these three into useEhrSync; their subUrls carry the
// ehr-api/ehr/ prefix because this branch's isEhr rule in Service/index.tsx passes
// ehr-athena/**, ehr-ecw/** and ehr-api/ehr/** through unchanged, and only
// prefixes bare paths with ehr-athena/ -- which the settings calls above
// rely on. development's rule was a blanket /api/, which they cannot use.

// Domains a patient can sync with the EHR (results, vitals, ...).
const getEHRCapabilities: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `ehr-api/ehr/patients/${payload.id1}/capabilities`,
    isEhr: true,
  };
  return get(request);
};

// Fetch one domain's data from the EHR.
const syncEHRDomains: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `ehr-api/ehr/patients/${payload.id1}/sync/${payload.data.domain}`,
    isEhr: true,
  };
  return post(request);
};

// Which EHR vendor a practice location is mapped to.
const syncEHRRouting: (payload: ApiServiceProps) => any = (payload) => {
  const request = {
    subUrl: `ehr-api/ehr/practice-locations/${payload.id1}/routing`,
    isEhr: true,
  };
  return post(request);
};

const EhrApi = {
  searchConnection,
  validateConnection,
  createConnection,
  updateConnection,
  deleteConnection,
  errFileDownload,
  manualPatientSync,
  patientResourceSync,
  patientParallelSync,
  downloadDocumentReference,
  downloadClinicalDocument,
  pushClinicalDocument,
  pushPatientCase,
  searchPatientCases,
  listProviders,
  prepareClaim,
  pushClaim,
  getEHRCapabilities,
  syncEHRDomains,
  syncEHRRouting,
};

export default EhrApi;
